import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProportionalFeeder = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 100,
	viewBox: "0 0 100.0 100.0",
	...props,
	children: [/* @__PURE__ */ _jsx("ellipse", {
		cx: 50,
		cy: 50,
		rx: 50,
		ry: 50,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 10.0 20.0 L 90.0 20.0 L 10.0 80.0 L 90.0 80.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgProportionalFeeder;
